package us.laantech.laanmanage.feature.reports.tax.ui

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.parameter
import io.ktor.http.ContentType
import io.ktor.http.contentType
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch
import us.laantech.common.dto.company.CompanyBranch
import us.laantech.common.api.KtorClient
import us.laantech.routes.pos.reports.z.ZReportDTO
import kotlin.time.Clock
import kotlin.time.Duration.Companion.days


data class TaxReportUiState(
    val fromMillis: Long = Clock.System.now().toEpochMilliseconds() - 7.days.inWholeMilliseconds,
    val toMillis: Long = Clock.System.now().toEpochMilliseconds(),

    val branches: List<CompanyBranch> = listOf(),
    val selectedBranch: CompanyBranch? = null,
    val report: ZReportDTO? = null,
    val showFromDatePicker: Boolean = false,
    val showToDatePicker: Boolean = false,
)


class TaxReportViewModel(): ViewModel() {

    private val _uiState = MutableStateFlow(TaxReportUiState())
    val uiState = _uiState.asStateFlow()
    val ktClient = KtorClient.instance.client

    suspend fun loadBranches() {
        val response = ktClient.get("/backoffice/store-management/list")
        val branches = response.body<List<CompanyBranch>>()
        println("Loaded branches: ${branches.size}")
        _uiState.update { it.copy(branches = branches) }
    }

    fun loadReport() {
        viewModelScope.launch {
            val response = ktClient.get("/backoffice/reports/tax") {
                contentType(ContentType.Application.Json)
                parameter("from_millis", uiState.value.fromMillis)
                parameter("to_millis", uiState.value.toMillis)
                parameter("branch_uuid", uiState.value.selectedBranch?.uuid)
            }
            val report = response.body<ZReportDTO>()
            _uiState.update { it.copy(report = report) }
        }
    }

    // Branch selection
    fun selectBranch(branch: CompanyBranch?) {
        _uiState.update { it.copy(selectedBranch = branch) }
        viewModelScope.launch { loadReport() }
    }

    // Date Time entry
    fun openFromDatePicker() { _uiState.update { it.copy(showFromDatePicker = true) } }
    fun closeFromDatePicker() { _uiState.update { it.copy(showFromDatePicker = false) } }
    fun openToDatePicker() { _uiState.update { it.copy(showToDatePicker = true) } }
    fun closeToDatePicker() { _uiState.update { it.copy(showToDatePicker = false) } }
    fun updateFromTime(epochMillis: Long) {
        _uiState.update { it.copy(fromMillis = epochMillis) }
        viewModelScope.launch { loadReport() }
    }
    fun updateToTime(epochMillis: Long) {
        _uiState.update { it.copy(toMillis = epochMillis) }
        viewModelScope.launch { loadReport() }
    }

}